import { useMemo } from 'react';
import useLocalize from '../../utils/hooks/useLocalize';
import ScanResultsTable from './ScanResultsTable';
import scanResultController from './scanResultController';

const ScanResultsSection = () => {
  const localize = useLocalize();

  // Get combined scan results from multiple criteria
  const scanResults = useMemo(() => {
    // Combine both exchange and securityType scan results
    return scanResultController.getCombinedScanResults(
      ['exchange', 'securityType'],
      50
    );
  }, []);

  return (
    <div className="scan-results-section">
      <h3>{localize('scan.result.title') || 'Scan Results'}</h3>
      <ScanResultsTable scanResults={scanResults} />
    </div>
  );
};

export default ScanResultsSection;
